import Http from "./http";

export const createAiCampaignAPI = (payload) => {
  return Http.post("admin/campaign/create", payload);
};
